import { useEffect, useRef, useState } from 'react';
import type { MouseEvent } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './index.css';
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp';
import serviceIconApps from '../../assets/images/service-icon-apps.webp';
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp';
import serviceIconWebsite from '../../assets/images/service-icon-website.webp';

const serviceLinks = [
  { title: 'Custom 3D Prints', path: '/services/3dprints', icon: serviceIcon3dPrint },
  { title: 'Websites', path: '/services/websites', icon: serviceIconWebsite },
  { title: 'App Development', path: '/services/appdev', icon: serviceIconApps },
  { title: 'Tech Consulting', path: '/services/consulting', icon: serviceIconConsulting },
];

const ServicesSubMenu = () => {
  const navigate = useNavigate();
  const navigationTimerRef = useRef<number | null>(null);
  const [selectedPath, setSelectedPath] = useState<string | null>(null);

  useEffect(() => () => {
    if (navigationTimerRef.current !== null) {
      window.clearTimeout(navigationTimerRef.current);
    }
  }, []);

  const handleServiceClick = (
    event: MouseEvent<HTMLAnchorElement>,
    path: string,
  ) => {
    if (
      event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
    ) {
      return;
    }

    event.preventDefault();

    if (navigationTimerRef.current !== null) {
      return;
    }

    setSelectedPath(path);
    navigationTimerRef.current = window.setTimeout(() => {
      navigationTimerRef.current = null;
      navigate(path);
    }, 1000);
  };

  return (
    <div className="services-submenu" role="navigation" aria-label="Service pages">
      {serviceLinks.map((service) => (
        <NavLink
          key={service.path}
          to={service.path}
          aria-label={service.title}
          aria-disabled={selectedPath !== null && selectedPath !== service.path}
          title={service.title}
          onClick={(event) => handleServiceClick(event, service.path)}
          className={({ isActive }) =>
            [
              'services-submenu-link',
              selectedPath === service.path ? 'selecting' : '',
              isActive && selectedPath === null ? 'active' : '',
            ].filter(Boolean).join(' ')
          }
        >
          <img src={service.icon} alt="" aria-hidden="true" />
        </NavLink>
      ))}
    </div>
  );
};

export default ServicesSubMenu;
